import { type PortfolioAndRecommendationsDataWrapper_userProfile$key } from '#app/__generated__/relay/PortfolioAndRecommendationsDataWrapper_userProfile.graphql.js';
import { PortfolioAndRecommendations } from './PortfolioAndRecommendations.js';
import { graphql, useFragment } from '@contra/relay';

export const PortfolioAndRecommendationsDataWrapper = ({
  accountRef,
}: {
  readonly accountRef: PortfolioAndRecommendationsDataWrapper_userProfile$key;
}) => {
  const data = useFragment(
    graphql`
      fragment PortfolioAndRecommendationsDataWrapper_userProfile on UserProfile {
        hasActivePortfolioSubscription
        hasPublishedPortfolio
        displayUsername
        userReviews(
          filter: { isPositiveReview: true, onlyVisibleToRecipient: false }
        ) {
          count
          edges {
            node {
              id
              author {
                id
                avatarImage {
                  uid
                }
              }
            }
          }
        }
      }
    `,
    accountRef,
  );

  const {
    displayUsername,
    hasActivePortfolioSubscription,
    hasPublishedPortfolio,
  } = data;

  const userReviews = {
    count: data.userReviews.count,
    reviews: data.userReviews.edges.map((edge) => ({
      author: {
        avatarImage: edge.node.author?.avatarImage?.uid
          ? {
              uid: edge.node.author.avatarImage.uid,
            }
          : null,
        id: edge.node.author.id,
      },
      id: edge.node.id,
    })),
  };

  const hasActiveSubscriptionAndPublishedPortfolio =
    hasActivePortfolioSubscription && hasPublishedPortfolio;

  return (
    <PortfolioAndRecommendations
      displayUsername={displayUsername}
      hasActiveSubscriptionAndPublishedPortfolio={
        hasActiveSubscriptionAndPublishedPortfolio
      }
      userReviews={userReviews}
    />
  );
};
